import "./DataReader.css";

// DataReader displays the current entry's data.
function DataReader({ rowIndex, scoreData = [], colIndexes }) {


  // Get the current entry's level, style, and size
  const { entryNumIdx, titleIdx, choreoIdx, dancerIdx, styleIdx, levelIdx, sizeIdx, numDancersIdx, schoolIdx } = colIndexes;





  // if (loading) return <div>Loading first row...</div>;
  // if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!scoreData || scoreData.length < 2)
    return <div>Loading...</div>;

  // Only show the first 9 columns for display
  const headers = scoreData[0].slice(0, 9);
  const values = scoreData[rowIndex]?.slice(0, 9) || [];

  const entryNum = scoreData[rowIndex]?.[entryNumIdx];
  if (!entryNum) {
    const label = scoreData[rowIndex]?.[titleIdx] || "AWARDS";
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", padding: "16px 0" }}>
        <div style={{ fontSize: "1.5rem", fontWeight: 700, letterSpacing: 2, color: "#555", textTransform: "uppercase" }}>
          {label}
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      {/* Main content box */}
      <div style={{ flex: 1 }}>
        <div style={{ position: "relative" }}>
          {/* Display entry data: first line side by side, rest below */}
          <div>
            {/* First line: Level of Entry, Dance Style, Size as large heading */}
            <div className="ossdf-datareader-heading">
              <span>{headers[entryNumIdx]}<span style={{ fontWeight: 400 }}>{values[entryNumIdx]}</span></span>
              <span style={{ paddingLeft: 10, fontWeight: 400 }}>{values[titleIdx]}</span>
            </div>
            {/* Second line: Entry Number and Dance Title as subheading */}
            <div className="ossdf-datareader-subheading">
              Category: 
              {levelIdx !== -1 && <span>{scoreData[rowIndex]?.[levelIdx]} </span>}
              {styleIdx !== -1 && <span>{scoreData[rowIndex]?.[styleIdx]} </span>}
              {sizeIdx !== -1 && <span>{scoreData[rowIndex]?.[sizeIdx]} </span>}
            </div>
            <div>
              {/* Choreographer(s), Dancer(s), and School as a table */}
              <table className="ossdf-datareader-table">
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: 'top', fontWeight: 600, width: '30%' }}>Choreographer(s):</td>
                    <td style={{ verticalAlign: 'top', width: '70%' }}>{scoreData[rowIndex]?.[choreoIdx] || ""}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: 'top', fontWeight: 600, width: '30%' }}>
                      Dancer(s):{numDancersIdx !== -1 && scoreData[rowIndex]?.[numDancersIdx] ? (
                        <span style={{ color: '#888', fontWeight: 400, marginLeft: 6 }}>
                          ({scoreData[rowIndex][numDancersIdx]} dancers)
                        </span>
                      ) : null}
                    </td>
                    <td style={{ verticalAlign: 'top', width: '70%' }}>
                      {scoreData[rowIndex]?.[dancerIdx] || ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: 'top', fontWeight: 600, width: '30%' }}>School:</td>
                    <td style={{ verticalAlign: 'top', width: '70%' }}>{scoreData[rowIndex]?.[schoolIdx] || scoreData[rowIndex]?.[schoolIdx] || ""}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataReader;
